import { render } from "./MainImage2.vue?vue&type=template&id=5910ba5a"
import script from "./MainImage2.vue?vue&type=script&lang=js"
export * from "./MainImage2.vue?vue&type=script&lang=js"
script.render = render

export default script